<template lang="pug">
  nav-menu(
    :options="options",
    v-model="menuSelected")
</template>

<script>
import stringsUtil from '@/utils/strings';

import NavMenu from '@/components/NavMenu.vue';

export default {
  name: 'GamesMenu',
  components: {
    NavMenu,
  },
  props: {
    games: {
      required: true,
    },
    value: {
      required: true,
    },
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  data() {
    return {
      menuSelected: this.value,
    };
  },
  computed: {
    options() {
      const gameOptions = this.games.map(game => ({
        name: this.unslugify(game.map),
        key: game.gameId,
        disabled: !game.stats,
      }));

      return [
        {
          name: 'Overall',
          key: 0,
          disabled: false,
        },
      ].concat(gameOptions);
    },
  },
  methods: {
    unslugify: stringsUtil.unslugify,
  },
  watch: {
    menuSelected(to) {
      this.$emit('change', to);
    },
    value(to) {
      this.menuSelected = to;
    },
  },
};
</script>
